<template>
  <div class="launchpack-delivery">
    <!-- 반품 검사 -->
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    ></admin-filter>

    <!-- 탭 2 -->
    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength" v-if="selectedTab===1">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(`${props.item.order.id}&page=OrderListReturning`)" class="unselect" style="text-decoration:underline">{{ props.item.id }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.name }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div class="flex align-center">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px" v-if="props.item.product.img">
          <div style="text-align: left">
            <div>{{ props.item.product.name }}</div>

            <div
              v-for="(option, option_idx) in props.item.order_product_option"
              :key="'option-'+option_idx">
              <span v-if="option.option.option_type===0">기본옵션:</span>
              <span v-if="option.option.option_type===1">추가옵션:</span>
              {{ optionFullName(option) }}
            </div>
          </div>
        </div>
      </td>

      <!-- 수량 -->
      <td slot="quantity" slot-scope="props">{{ props.item.quantity }}</td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배송 금액 -->
      <td slot="delivery_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.delivery_cost | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.total_price | currency }}</td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props">
        <div v-if="props.item.partner">{{ props.item.partner }}</div>
        <div v-else>-</div>
      </td>

      <td slot="status_change" slot-scope="props">
        <button class="button"
                style="width:130px"
                @click="clickDetail(`${props.item.order.id}&page=OrderListReturning`)">반품 정보 입력</button>
      </td>

      <!-- 주문 상태 -->
      <td slot="status_kor" slot-scope="props">{{ props.item.status_kor }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type }}</span></td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리</button>
        </div>
      </div>
    </order-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <!-- 반품 요청 철회 -->
    <modal name="cancelRefundModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="반품 요청 철회" :useTab="false" class="lp-modal-wrapper">
        <div>반품 요청을 철회하면 이전 상태로 돌아갑니다. 철회 하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelRefundModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelRefundModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import DeliveryMixin from "@/mixins/DeliveryMixin"

  export default {
    name: 'OrderListReturning',
    components: {LpCheckBool},
    mixins: [
      DeliveryMixin
    ],
    data() {
      return {
      }
    },
    watch: {
      selectedTab(n){
        if(this.selectedTab===0){
          this.initializing('returning', 'delivery/order?status=702', 'OrderListReturning');
        }
        if(this.selectedTab===1){
          this.initializing('returning', 'delivery/orderproduct?status=702', 'OrderListReturning');
        }
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // (테이블 필드, 사용할 api, 현재페이지)
        this.initializing('returning', 'delivery/orderproduct?status=702', 'OrderListReturning');
      },
      getDataFromServer() {
        this.getData();
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
